<div
  class="card card-custom"
  [ngClass]="{ 'card-body-progress card-body-progress-overlay': viewLoading }"
>
  <div *ngIf="data.title" class="card-header">
    <div class="card-title">
      <h3 class="card-label">Please Confirm the Following Information</h3>
    </div>
  </div>

  <form class="form" [formGroup]="form" autocomplete="off">
    <div class="card-body">
      <div class="card-body-progress">
        <mat-spinner [diameter]="20"></mat-spinner>
      </div>

      <div class="form-section form-section-first">
        <h5>{{ contact.first_name }} {{ contact.last_name }}</h5>
        <div>
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label>Email</mat-label>
            <input matInput formControlName="contactEmail" />
            <mat-error *ngIf="form.controls['contactEmail'].hasError('required')">
              Email is required if Phone Number not provided.
            </mat-error>
            <mat-error *ngIf="form.controls['contactEmail'].hasError('email')">
              Invalid email address.
            </mat-error>
          </mat-form-field>
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label>Phone Number</mat-label>
            <input
              matInput
              formControlName="contactPhone"
              maxlength="14"
              ktAppPhoneMask
              autocomplete="kt-contact-cellphone"
            />
            <mat-error *ngIf="form.controls['contactPhone'].hasError('required')">
              Phone Number is required if Email not provided.
            </mat-error>
            <mat-error *ngIf="form.controls['contactPhone'].hasError('pattern')">
              Phone number not in the correct format.
            </mat-error>
            <mat-error *ngIf="form.controls['contactPhone'].hasError('minlength')">
              Minimum of 10 digits in phone field.
            </mat-error>
            <mat-error *ngIf="form.controls['contactPhone'].hasError('maxlength')">
              Maximum of 10 digits in phone field.
            </mat-error>
          </mat-form-field>
        </div>

        <hr class="mb-15px" />

        <mat-radio-group formControlName="method">
          <mat-radio-button value="file" [checked]="form.get('method').value === 'file'"
            >File Upload</mat-radio-button
          >
        </mat-radio-group>

        <mat-radio-group formControlName="method">
          <mat-radio-button value="esignature" [checked]="form.get('method').value === 'esignature'"
            >E-Signature</mat-radio-button
          >
        </mat-radio-group>

        <mat-error *ngIf="form.controls['method'].hasError('required')">
          Agreement Method is Required
        </mat-error>

        <hr class="mb-15px" />

        <div *ngIf="form.get('method').value === 'esignature'">
          <h5>Office</h5>
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label>Office</mat-label>
            <mat-select formControlName="office" (selectionChange)="onOfficeChange($event)">
              <mat-option *ngFor="let office_id of offices" [value]="office_id">
                {{ getOfficeName(office_id) }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="form.controls['office'].hasError('required')">
              Office is required.
            </mat-error>
          </mat-form-field>

          <h5>Agreement Template</h5>
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label>Agreement Template</mat-label>
            <mat-select [disabled]="!officeSelected" formControlName="agreementTemplate">
              <mat-option *ngFor="let template of templates$ | async" [value]="template.id">
                {{ template.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="form.controls['agreementTemplate'].hasError('required')">
              Template is required if no agreement document provided.
            </mat-error>
          </mat-form-field>
        </div>

        <div *ngIf="form.get('method').value === 'file'">
          <h5>Office</h5>
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label>Office</mat-label>
            <mat-select formControlName="fileUploadOffice" [disabled]="true">
              <mat-option *ngFor="let office of data.offices" [value]="office.id">
                {{ office.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <h5>Agreement Document</h5>
          <div class="file-input mb-6" (click)="fileInput.click()">
            <div>
              <div>
                <mat-form-field appearance="fill">
                  <mat-label>Agreement Document</mat-label>
                  <input matInput required readonly type="text" formControlName="fileName" />
                  <input
                    #fileInput
                    required
                    hidden
                    type="file"
                    accept=".pdf"
                    (change)="changeFile($event)"
                  />
                  <mat-hint>Accepted file type .pdf</mat-hint>
                </mat-form-field>
              </div>
              <span
                matTooltip="{{ 'TABLE.ATTACH' | translate }} File"
                class="btn btn-icon btn-light-primary btn-hover-primary"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/attachment.svg"
                  class="svg-icon svg-icon-lg svg-icon-primary"
                ></span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
  <div
    tabindex="0"
    class="card-footer d-flex justify-content-end"
    (keydown.enter)="onEnterKey($event)"
  >
    <button
      #cancelButton
      mat-raised-button
      cdkFocusInitial
      style="width: 100px !important"
      class="btn btn-sm btn-light"
      (click)="onNoClick()"
    >
      {{ 'GLOBAL.CANCEL' | translate }}
    </button>
    <button
      #confirmButton
      *ngIf="!data.hideConfirmBtn"
      mat-raised-button
      [disabled]="viewLoading"
      style="width: 100px !important"
      class="btn btn-sm btn-primary ml-4"
      (click)="onYesClick()"
    >
      {{ 'GLOBAL.CONFIRM' | translate }}
    </button>
  </div>
</div>
